// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__3HROD","input":"styles_input__211z-","icon":"styles_icon__fyTtp","link":"styles_link__1cR_v"};